import React from 'react';
import { Button, Form } from 'antd';
import TextInput from '../inputs/TextInput';
import CheckInput from '../inputs/CheckInput';
import useTranslation from '../../hooks/translation/useTranslation';

function StationForm({
  form, onFinish, errors, isLoading,
}) {
  const { trans } = useTranslation();
  return (
    <Form
      form={form}
      onFinish={onFinish}
      layout="vertical"
    >
      <TextInput
        label={trans('system_id')}
        errorMessage={errors?.station_id}
        name="station_id"
        disabled
      />
      <TextInput
        label={trans('name_ka')}
        name="name_ka"
        errorMessage={errors?.name_ka}
      />
      <TextInput
        label={trans('name_en')}
        name="name_en"
        errorMessage={errors?.name_en}
      />
      <TextInput
        label={trans('name_ru')}
        name="name_ru"
        errorMessage={errors?.name_ru}
      />
      <TextInput
        label={trans('name')}
        name="name"
        errorMessage={errors?.name}
        disabled
      />
      <TextInput
        label={trans('system_code')}
        name="station_code"
        errorMessage={errors?.station_code}
        disabled
      />
      <TextInput
        label={trans('country')}
        name="station_country"
        errorMessage={errors?.station_country}
        disabled
      />
      <TextInput
        label={trans('priority')}
        name="priority"
        errorMessage={errors?.priority}
      />
      <CheckInput
        label={trans('hide')}
        name="hide"
      />
      <Form.Item>
        <Button type="primary" htmlType="submit" loading={isLoading}>
          {trans('submit')}
        </Button>
      </Form.Item>
    </Form>
  );
}

export default StationForm;
